<div class="search-results-overlay">
  <div class="search-results-overlay-layout">
    @if (isSearching()) {
      @if (availableFilterItems().length > 0) {
        <ftr-search-type-filter
          [availableFilterItems]="availableFilterItems()"
          (onFilterItemSelected)="handleFilterItemSelected($event)"
        >
        </ftr-search-type-filter>
      }
      <ftr-global-search-results
        [searchTerm]="searchTerm()"
        [configuration]="configuration()"
        [entitiesToSearch]="entitiesToSearch()"
        [searchResponse]="searchResponse()"
        [searchFocusState]="searchFocusState()"
        (onItemSelected)="(onItemSelected.emit)"
        (onNewSearchFocusState)="onNewSearchFocusState.emit($event)"
        (onRetry)="onRetry.emit($event)"
      >
      </ftr-global-search-results>
    }
  </div>
</div>
